const AmountCharged = (imageCount, numberOfImages, netPrice, shipmentCost, selectedCoupon, handlingFee = 0.36, creditsApplied = 0, giftCardValue = 0) => {
    // Calculate total handling fee (0.36 ILS per image)
    const totalHandlingFee = imageCount * handlingFee;

    const shippingPortion = imageCount >= numberOfImages ? 0 : shipmentCost;
    const chargedAmount = netPrice + shippingPortion + totalHandlingFee;

    const afterCoupon = selectedCoupon?.discountPrice ? chargedAmount - selectedCoupon?.discountPrice : chargedAmount;

    // Credits only reduce the non-shipping portion — shipping is paid in full unless waived by the image-count tier
    const creditEligible = Math.max(afterCoupon - shippingPortion, 0);
    const creditsUsed = creditsApplied > 0 ? Math.min(creditsApplied, creditEligible) : 0;
    const afterCredits = afterCoupon - creditsUsed;

    // Gift-card frames also reduce only the non-shipping portion (same rule as credits)
    const giftEligible = Math.max(afterCredits - shippingPortion, 0);
    const giftUsed = giftCardValue > 0 ? Math.min(giftCardValue, giftEligible) : 0;
    const finalAmount = afterCredits - giftUsed;

    // Ensure minimum amount of 2 ILS and round to 2 decimal places. A gift card in the
    // coupon slot may cover the whole order: ₪0, completed without a payment step.
    return parseFloat(Math.max(finalAmount, selectedCoupon?.giftCard ? 0 : 2).toFixed(2));
}

export default AmountCharged;
